'use client'

import React from 'react'
import { ArtBlocksWordmarkLockupFullColor, XIcon } from 'design-configuration/components'
import * as Dialog from '@radix-ui/react-dialog'
import { USING_PROXY } from '@/app/constants/common'
import Link from 'next/link'
import { AnimatePresence, motion } from 'motion/react'

type DismissOutsideModalProps = {
  children: React.ReactNode
  onDismiss: () => void
  visible: boolean
  containerClassName?: string
}

export function DismissOutsideModal({
  children,
  onDismiss,
  visible,
  containerClassName
}: DismissOutsideModalProps): React.ReactNode {
  return (
    <Dialog.Root open={visible} onOpenChange={onDismiss}>
      <AnimatePresence mode="wait">
        {visible ? (
          <Dialog.Portal forceMount>
            <Dialog.Overlay asChild>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="bg-surface/90 fixed inset-0 top-0 z-[60] flex items-start justify-center overflow-y-auto backdrop-blur-[25px]"
              >
                <Dialog.Content
                  className={`w-full bg-transparent bg-opacity-100 ${containerClassName ? containerClassName : ''}`}
                >
                  <div className="p-md flex w-full flex-row items-center justify-between">
                    <Link href={USING_PROXY ? '/curated' : '/'} onClick={() => onDismiss()}>
                      <ArtBlocksWordmarkLockupFullColor className="fill-on-surface h-[30px]" />
                    </Link>
                    <button onClick={() => onDismiss()}>
                      <XIcon className="fill-on-surface w-sm h-sm" />
                    </button>
                  </div>
                  {children}
                </Dialog.Content>
              </motion.div>
            </Dialog.Overlay>
          </Dialog.Portal>
        ) : undefined}
      </AnimatePresence>
    </Dialog.Root>
  )
}
